import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';

export const ButtonGroupWithNowrap = styled(ButtonGroup)`
    flex-wrap: nowrap;

    ${Button}:first-child {
        flex: 1;
    }
`;
